// extracted by mini-css-extract-plugin
export default {"arrow":"SortArrow_arrow__h1Tz+","down":"SortArrow_down__eA2vv","disabled":"SortArrow_disabled__n3swo"};